import {RootState} from "global/store";
import {useSelector as useReduxSelector} from "react-redux";

export const useAppSelector = <T extends keyof RootState>(
  key: T
): RootState[T] => {
  return useReduxSelector((state: RootState) => state[key]);
};
